(() => {
  if (window.foodyCommunityPageLoaded) return;
  window.foodyCommunityPageLoaded = true;
  const cleanups = new WeakMap();
  function init(scope = document) {
    scope.querySelectorAll('[data-foody-community]').forEach(root => {
      if (cleanups.has(root)) return;
      const controller = new AbortController();
      const options = { signal: controller.signal };
      const slider = root.querySelector('.community-reviews');
      const config = JSON.parse(root.querySelector('[data-community-config]')?.textContent || '{}');
      const max = Math.max(config.slidesPerView, ...Object.values(config.breakpoints || {}).map(b => b.slidesPerView));
      config.loop = config.loop && (slider?.querySelectorAll('.swiper-slide').length || 0) >= max + 1;
      const swiper = slider && typeof window.Swiper === 'function' ? new window.Swiper(slider, { ...config, speed: matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 500, rewind: !config.loop, pagination: { el: root.querySelector('.community-pagination'), clickable: true }, keyboard: { enabled: true, onlyInViewport: true }, a11y: { enabled: true }, watchOverflow: true }) : null;
      const dialog = root.querySelector('[data-community-dialog]');
      if (!dialog) { cleanups.set(root, () => { controller.abort(); swiper?.destroy(true, true); }); return; }
      const video = dialog.querySelector('video');
      const photo = dialog.querySelector('.media-photo');
      const status = dialog.querySelector('[data-community-status]');
      let opener;
      let generation = 0;
      function stop() { generation++; video.pause(); video.removeAttribute('src'); video.removeAttribute('poster'); video.load(); photo.removeAttribute('src'); window.FoodyText.set(status, ''); }
      root.addEventListener('click', event => {
        const card = event.target.closest('[data-community-card]');
        if (card) {
          stop();
          opener = card;
          const token = generation;
          const img = card.querySelector('img');
          const isVideo = Boolean(card.dataset.video);
          window.FoodyText.set(dialog.querySelector('[data-community-title]'), card.dataset.title, card);
          window.FoodyText.set(dialog.querySelector('[data-community-note]'), card.dataset.note, card);
          video.hidden = !isVideo;
          photo.hidden = isVideo;
          if (isVideo) { video.poster = img.currentSrc || img.src; video.src = card.dataset.video; video.setAttribute('aria-label', card.dataset.title); }
          else { photo.src = img.currentSrc || img.src; photo.alt = card.dataset.title; }
          dialog.showModal();
          if (isVideo) video.play().catch(() => { if (dialog.open && token === generation && !video.error) window.FoodyText.set(status, root.dataset.playHint); });
        }
        if (event.target.closest('[data-community-close]')) dialog.close();
        if (event.target === dialog) {
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        }
      }, options);
      video.addEventListener('error', () => { if (dialog.open && video.hasAttribute('src')) window.FoodyText.set(status, root.dataset.error); }, options);
      dialog.addEventListener('close', () => { stop(); opener?.focus(); }, options);
      cleanups.set(root, () => { controller.abort(); stop(); if (dialog.open) dialog.close(); swiper?.destroy(true, true); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true }); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-foody-community]').forEach(root => { cleanups.get(root)?.(); cleanups.delete(root); }));
})();
